import { useState } from "react"
import { useNavigate } from "react-router-dom"
import AdminLayout from "@/components/admin/AdminLayout"
import { createAdminMember } from "@/api/adminMemberApi"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function AdminMemberCreatePage() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState({
        loginId: "",
        password: "",
        memberName: "",
        email: "",
        phone: "",
        role: "USER",
        status: "ACTIVE",
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!form.loginId || !form.password || !form.memberName || !form.email) {
            return alert("필수 항목을 모두 입력해주세요.")
        }

        try {
            setLoading(true)
            await createAdminMember(form)
            alert("신규 회원이 성공적으로 등록되었습니다.")
            navigate("/admin/members")
        } catch (error: any) {
            console.error(error)
            // 백엔드에서 던진 IllegalArgumentException 메시지를 띄워줍니다.
            const errorMsg = error.response?.data?.message || "회원 등록 중 오류가 발생했습니다."
            alert(errorMsg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <AdminLayout>
            <div className="space-y-6">
                <div>
                    <h2 className="text-3xl font-bold">신규 회원 등록</h2>
                    <p className="mt-2 text-sm text-slate-500">
                        새로운 회원의 계정을 관리자가 직접 생성합니다.
                    </p>
                </div>

                <Card className="max-w-3xl rounded-[28px] border border-slate-200 shadow-sm">
                    <CardHeader>
                        <CardTitle className="text-xl">회원 정보 입력</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="grid gap-5 md:grid-cols-2">
                            <div className="space-y-2">
                                <Label>아이디 <span className="text-red-500">*</span></Label>
                                <Input name="loginId" value={form.loginId} onChange={handleChange} className="h-12 rounded-xl" placeholder="영문, 숫자 조합" required />
                            </div>
                            <div className="space-y-2">
                                <Label>초기 비밀번호 <span className="text-red-500">*</span></Label>
                                <Input type="password" name="password" value={form.password} onChange={handleChange} className="h-12 rounded-xl" placeholder="비밀번호 입력" required />
                            </div>
                            <div className="space-y-2">
                                <Label>이름 <span className="text-red-500">*</span></Label>
                                <Input name="memberName" value={form.memberName} onChange={handleChange} className="h-12 rounded-xl" placeholder="실명 입력" required />
                            </div>
                            <div className="space-y-2">
                                <Label>이메일 <span className="text-red-500">*</span></Label>
                                <Input type="email" name="email" value={form.email} onChange={handleChange} className="h-12 rounded-xl" placeholder="example@email.com" required />
                            </div>
                            <div className="space-y-2 md:col-span-2">
                                <Label>연락처</Label>
                                <Input name="phone" value={form.phone} onChange={handleChange} className="h-12 rounded-xl" placeholder="010-0000-0000" />
                            </div>
                            <div className="space-y-2">
                                <Label>권한</Label>
                                <select name="role" value={form.role} onChange={handleChange} className="h-12 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none">
                                    <option value="USER">일반 사용자 (USER)</option>
                                    <option value="ADMIN">관리자 (ADMIN)</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <Label>계정 상태</Label>
                                <select name="status" value={form.status} onChange={handleChange} className="h-12 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none">
                                    <option value="ACTIVE">활성 (ACTIVE)</option>
                                    <option value="INACTIVE">비활성 (INACTIVE)</option>
                                </select>
                            </div>

                            <div className="md:col-span-2 flex justify-end gap-3 mt-8">
                                <Button type="button" variant="outline" className="rounded-xl h-12 px-6" onClick={() => navigate("/admin/members")} disabled={loading}>
                                    취소
                                </Button>
                                <Button type="submit" disabled={loading} className="rounded-xl h-12 px-8 bg-slate-900 hover:bg-slate-800 text-white">
                                    {loading ? "등록 중..." : "회원 등록하기"}
                                </Button>
                            </div>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </AdminLayout>
    )
}